import { cx } from "~utils";
import styles from "./header.module.css";

const ListPageHeader = ({ title, description = "", isAlwaysCentered = false }) => {
  return (
    <div
      className={cx(styles.articleListHeader, isAlwaysCentered ? styles.centerHeader : "")}
      data-testid="list-page-header-element"
    >
      <h1
        className={cx(styles.title, isAlwaysCentered ? styles.centerHeader : "")}
        data-testid="list-page-header-element"
      >
        {title}
      </h1>
      <div
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: description }}
        data-testid="list-page-header-element"
      ></div>
    </div>
  );
};

export default ListPageHeader;
